import { memo, type ReactNode } from 'react';

import { AllContent } from '~/components/AllContent/AllContent';
import { GENERAL_PAGE_ID, useBoardlessConfigView } from '~/hooks/useBoardlessConfigView/useBoardlessConfigView';

export type AllContentPageProps = {
  children: ReactNode;
};

export const AllContentPage = memo(({ children }: AllContentPageProps) => {
  const { BoardlessConfigObserver } = useBoardlessConfigView({ pageId: GENERAL_PAGE_ID });

  return (
    <>
      {BoardlessConfigObserver}
      <AllContent />
      {children}
    </>
  );
});

AllContentPage.displayName = 'AllContentPage';
